import { render, staticRenderFns } from "./addDoor.vue?vue&type=template&id=159df254&scoped=true"
import script from "./addDoor.vue?vue&type=script&lang=js"
export * from "./addDoor.vue?vue&type=script&lang=js"
import style0 from "./addDoor.vue?vue&type=style&index=0&id=159df254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159df254",
  null
  
)

export default component.exports